export default __webpack_public_path__ + "static/media/oftmcss.816eb317.svg";